import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import privacyPolicyPdf from "../image/terms-conditions-pdfs/Dwellora_Homes_Privacy_Policy.pdf";
import helpSupportPdf from "../image/terms-conditions-pdfs/Dwellora_Homes_Help_and_Support.pdf";
import cookiesPolicyPdf from "../image/terms-conditions-pdfs/Dwellora_Homes_Cookies_Policy.pdf";
import creditsPdf from "../image/terms-conditions-pdfs/Dwellora_Homes_Credits.pdf";

function Footer({ openContactModal, showCTA })
 {

  const [isMobile, setIsMobile] = useState(false);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 576);
  };

  handleResize(); 
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    const words = document.querySelectorAll(".dw-faq-heading .dw-word");
    let current = 0;

    if (!words.length) return;

    const interval = setInterval(() => {
      words.forEach((word) => {
        word.classList.remove("active");

        const oldBox = word.querySelector(".dw-corner-box");
        if (oldBox) oldBox.remove();
      });

      words[current].classList.add("active");

      const box = document.createElement("span");
      box.className = "dw-corner-box";
      words[current].prepend(box);

      current++;
      if (current >= words.length) current = 0;
    }, 900);

    return () => clearInterval(interval);
  }, []);

  const faqData = [
  {
    question: "Is Dwellora Homes a government-registered company?",
    answer:
      "Yes. Dwellora operates under Dwellora Designs LLP, a legally registered Limited Liability Partnership with the Ministry of Corporate Affairs (ROC), Government of India.<br/>This ensures compliant, accountable, and professional operations.",
  },
  {
    question: "Who leads Dwellora and what experience does the team have?",
    answer:
      "Dwellora is led by Architect Gajanan V. Shetkar, founder of S-Cube Designers & Planners (est. 2015) — bringing over 11 years of professional design and construction experience.<br/>The team also includes civil engineering partners with 20+ years of construction expertise, combining strong architectural planning with practical execution capability.",
  },
  {
    question: "How can I trust Dwellora with my home construction?",
    answer:
      "Trust for us goes beyond being a registered company or having a COA-registered architect leading the firm.<br/>At Dwellora, we believe real trust comes from complete transparency in how your home is built.<br/>From day one of construction, we provide live site camera access so you can monitor work progress anytime, from anywhere — whether you are at work or traveling.<br/>This openness ensures you always know how your home is being built, without constant follow-ups.",
  },
  {
    question: "How does Dwellora deliver high-quality construction at the right price?",
    answer:
      "Dwellora operates with a fully in-house team covering architecture, approvals, and construction execution. We do not subcontract projects to external contractors or add third-party commission layers.<br/>This integrated approach removes multiple margin layers and coordination gaps, allowing us to maintain high construction quality while keeping project costs efficient and transparent.",
  },
  {
    question: "How does Dwellora ensure on-time project delivery?",
    answer:
      "Dwellora provides a registered agreement with defined scope and completion timeline for full customer assurance.<br/>With our dedicated in-house execution team, we maintain strong schedule control — enabling reliable and timely project delivery.",
  },
  {
    question: "I already have a plot. Can Dwellora handle everything from design to construction?",
    answer:
      "Yes. Dwellora provides complete bungalow solutions — architectural design, PMRDA approvals, and construction — all managed by one professional team. You don’t need to coordinate with separate architects, engineers, and contractors.",
  },
  {
    question: "How is Dwellora different from a local contractor?",
    answer:
      "A contractor typically executes only construction.<br/>Dwellora is an architect-led, government-registered LLP delivering design, approvals, and construction together. This ensures better planning, cost control, compliance, and overall quality.",
  },
  {
    question: "I’m worried about cost overruns. How does Dwellora control budget?",
    answer:
      "We provide transparent per-sqft pricing and detailed scope before starting.<br/>Because design and construction are integrated, there are fewer changes, errors, and rework — the main reasons projects exceed budget.",
  },
  {
  question: "Do I need to arrange an architect or approval agent separately?",
  answer:
    "No, you don’t need to arrange them separately.<br/>Architecture and PMRDA liaisoning are included in Dwellora’s services. This means you get a single point of contact for design, approvals, and construction, ensuring smoother communication and project execution."
},
  {
    question: "Will my home design be customized or standard?",
    answer:
      "Every Dwellora home is custom-designed for your plot size, orientation, family needs, and vastu preferences.<br/>We focus on practical space planning, ventilation, and long-term usability — not template designs.",
  },
  {
    question: "What do your ₹1300 and ₹1900 per sqft packages include?",
    answer:
      "₹1300/sqft covers structure (RCC, brickwork, plaster) plus architectural design, drawings, and local authority approvals.<br/>₹1900/sqft includes full finishing construction along with design and approvals.<br/>Detailed specifications are shared before agreement.",
  },
  {
    question: "Who manages quality and site supervision?",
    answer:
      "Dwellora’s architectural and engineering team plans and monitors execution.<br/>Because design and construction are handled together, site decisions remain aligned with drawings and specifications.",
  },
  {
    question: "How are payments scheduled?",
    answer:
      "Payments are stage-linked to construction progress (foundation, plinth, slab, finishing, etc.).<br/>This keeps financial flow balanced and transparent for homeowners.",
  },
  {
    question: "Will approvals and regulations be properly handled?",
    answer:
      "Yes. Dwellora prepares compliant drawings and assists PMRDA approval processes.<br/>This reduces legal risk, delays, and rework during construction.",
  },
  {
    question: "Why do many plot owners choose integrated design-build firms like Dwellora?",
    answer:
      "Because a single responsible team reduces coordination stress, timeline delays, and cost variations.<br/>Homeowners get clearer accountability, smoother execution, and predictable outcomes.",
  },
];

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
    <section id="site-footer" className="dw-faq-footer-wrapper">

      {/* FAQ SECTION */}
      <div className="dw-faq-section">
        <div className="container-fluid">
          <div className="row">

            {/* LEFT TEXT */}
            <div className="col-lg-6">
              <div className="dw-faq-left">
                <h2 className="dw-faq-heading">
                  {/* <span className="dw-word active">
                    <span className="dw-corner-box"></span>
                    Let’s
                  </span>{" "}
                  <span className="dw-word">us</span> <br />
                  <span className="dw-word">listen</span>{" "}
                  <span className="dw-word">to</span>{" "}
                  <span className="dw-word">your</span> <br />
                  <span className="dw-word">problems</span> */}
Frequently Asked 
Questions

                </h2>

                <p>
                 Have questions about our homes, pricing, or benefits? Explore our FAQs to get quick and simple answers.
                </p>
              </div>
            </div>

            {/* RIGHT FAQ LIST */}
            <div className="col-lg-6">
              <div className="dw-faq-right">
                {/* <h3 className="dw-faq-title">Dwellora Homes – Smart FAQ</h3>
<p className="dw-faq-scrollhint">Scroll to explore more FAQs ↓</p> */}

                {/* {faqData.map((faq, index) => ( */}
            {(isMobile ? faqData.slice(0, 2) : faqData.slice(0, 3)).map((faq, index) => (
  <div
    key={index}
    className={`dw-faq-item ${activeIndex === index ? "active" : ""}`}
    onClick={() => toggleFaq(index)}
  >
    <div className="dw-faq-question-row">
      <span className="dw-faq-question-text">{faq.question}</span>

      <span className="dw-faq-arrow">
        {activeIndex === index ? "−" : "+"}
      </span>
    </div>

    <div className="dw-faq-answer">
      <p dangerouslySetInnerHTML={{ __html: faq.answer }} />
    </div>
  </div>
))}

{/* VIEW ALL BUTTON (mobile + desktop dono me) */}

<div className="dw-faq-viewall">
    <Link to="/faq" state={{ scrollToTop: true }}>
      View All FAQs →
    </Link>
  </div>
                {/* {isMobile && (
  <div className="dw-faq-viewall">
    <Link to="/faq">View All FAQs →</Link>
  </div>
)} */}

{/* {isMobile && (
  <div className="dw-faq-viewall">
    <Link to="/faq" state={{ scrollToTop: true }}>
      View All FAQs →
    </Link>
  </div>
)} */}

              </div>
            </div>
          </div>
        </div>


      </div>


      {/* CENTER CTA BOX */}
      <div className="dw-footer-cta-box">
        <h4>
          From Design to Delivery Starting at <span>₹1250/Sq.Ft*</span>
          
        </h4>

        <p>
         Includes Grey Construction (RCC + Brickwork + Plaster), Architectural Design & Liaisoning Approvals

        </p>

        <div className="dw-footer-cta-btns">
          <Link to="/calculate">
            <button className="dw-footer-btn dark">Get a Free Quote</button>
          </Link>

          <button className="dw-footer-btn " onClick={openContactModal}>
           Let’s Consult
          </button>
        </div>

      </div>

      {/* FOOTER */}
      <footer className="dw-footer">
        <div className="container-fluid">
          <div className="row dw-footer-top">

            {/* LEFT */}
            <div className="col-lg-6">
              <div className="dw-footer-left">
                <h5 className="dw-footer-logo">Dwellora Homes</h5>

                <p
                  style={{
                    fontFamily: "'Petit Formal Script', cursive",
                    fontSize: "14px",
                    color: "#fff",
                  }}
                >
                  A Venture by Dwellora Design LLP
                </p>

                <p className="dw-footer-address">
                  Office : 601, The Stellar Complex, Bhumkar Das Gugre <br />
                  Rd, Wakad, Pune, Pimpri-Chinchwad, Maharashtra 411057
                </p>

                <h6 className="dw-footer-subtitle">
                  Not sure if Dwellora is right for you?
                </h6>

                <p className="dw-footer-smalltext">
                  Get in Touch with us for Details
                </p>
{/* 
                <div className="dw-footer-newsletter">
                  <input type="text" value="+91-9156-031-516" readOnly />
                  <input type="text" value="+91-9158-941-222" readOnly />
                  <input type="text" value="contact@dwellorahomes.com" readOnly />
                </div> */}

<div className="dw-footer-newsletter"> 

  <a href="tel:+919158914222">
    <input type="text" value="+91-9158-914-222" readOnly />
  </a>

  <a href="tel:+919158941222">
    <input type="text" value="+91-9158-941-222" readOnly />
  </a>

  <a href="mailto:contact@dwellorahomes.com">
    <input type="text" value="contact@dwellorahomes.com" readOnly />
  </a>

</div>
                
              </div>
            </div>

            {/* CENTER */}
            <div className="col-lg-3">
              <div className="dw-footer-center">
                <h5>Company</h5>

                <ul>
                  <li>
                    {/* <a href="#">Get a free quote</a> */}
                     <Link to="/calculate" className="footer-link">
                      Get a free quote
                    </Link>
                  </li>

                 

                  <li>
     {/* <a 
  href="https://contact.dwellorahomes.com/" 
  className="footer-link"
  target="_blank" 
  rel="noopener noreferrer"
>
  Calculate my Cost
</a> */}

<Link to="/estimate" className="footer-link">
                     Calculate my Cost
                    </Link>

                  </li>
             
                  <li>
                    <button
                      className="footer-contact-btn"
                      onClick={openContactModal}
                    >
                     Let’s Consult
                    </button>
                  </li>

 <li>
                    <Link to="/faq" className="footer-link">
                      FAQ 
                    </Link>
                  </li>

                </ul>
              </div>
            </div>

            {/* RIGHT */}
            <div className="col-lg-3">
              <div className="dw-footer-right">
                <h5>Follow us</h5>

                <div className="dw-footer-social">

 <a 
    href="https://wa.me/919158914222" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <i className="fab fa-whatsapp fs-5"></i>
  </a>

  <a 
    href="https://www.instagram.com/dwellora.homes/" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <i className="fab fa-instagram fs-5"></i>
  </a>

                  {/* <a href="#"><i className="fab fa-whatsapp"></i></a> */}
                  {/* <a href="#"><i className="fab fa-facebook-f"></i></a>
                  <a href="#"><i className="fab fa-linkedin-in"></i></a> */}
                  {/* <a href="#"><i className="fab fa-instagram"></i></a> */}
                  {/* <a href="#"><i className="fab fa-youtube"></i></a> */}
                </div>
              </div>
            </div>

          </div>

          {/* BOTTOM */}
          <div className="dw-footer-bottom-row">
            <div className="dw-footer-bottom-links">
              <a href={privacyPolicyPdf} target="_blank" rel="noopener noreferrer">Privacy</a>
              <a href={helpSupportPdf} target="_blank" rel="noopener noreferrer">Help</a>
              <a href={cookiesPolicyPdf} target="_blank" rel="noopener noreferrer">Cookies policy</a>
              <a href={creditsPdf} target="_blank" rel="noopener noreferrer">Credits</a>
            </div>

            <div className="dw-footer-copy">
              © 2026 Dwellora Designs LLP all rights reserved.
            </div>
          </div>
        </div>
      </footer>
    </section>

    {/* Mobile Get In Touch Section */}
{/* <div className="mobile-sticky-bar">

  <a href="tel:+919158914222">
    <i className="bi bi-telephone-fill"></i>
    Call
  </a>

  <a href="https://wa.me/919158914222" target="_blank" rel="noreferrer">
    <i className="bi bi-whatsapp"></i>
    WhatsApp
  </a>

  <a href="mailto:dwellorahomes@gmail.com">
    <i className="bi bi-envelope-fill"></i>
    Email
  </a>
</div> */}

{/* Mobile Scroll CTA Buttons */}
{/* <div className={`mobile-scroll-cta ${showCTA ? "show" : ""}`}> */}
<div className={`mobile-scroll-cta ${showCTA ? "show-cta" : ""}`}>

  <a href="tel:+919158914222" className="cta-btn consult">
    <i className="bi bi-telephone-fill"></i>
    Call Now
  </a>

  <button
    className="cta-btn quote"
    onClick={() => window.location.href = "/calculate"}
  >
    Get a Free Quote
  </button>

</div>

</>

  );


}

export default Footer;